import {
  SidepanelAccountingInfoDocument,
  SidepanelAccountingInfoQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type FinanceAccount = SidepanelAccountingInfoQuery['finance']['accounts'][number]

export const useLedgerAccountResources = ({
  legalEntityId,
  skip,
  types,
}: {
  legalEntityId?: number
  types?: string[]
  skip?: boolean
}) => {
  const { data: sidepanel, loading: loadingPage } = useQuery(SidepanelAccountingInfoDocument, {
    variables: { legalEntityIds: legalEntityId ? [legalEntityId] : undefined, types },
    skip: skip ?? false,
  })

  return {
    accounts: sidepanel?.finance?.accounts ?? [],
    canSee: sidepanel?.finance?._policies?.accountingSeeAccounts?.can ?? false,
    canManage: sidepanel?.finance?._policies?.accountingManageAccountResources?.can ?? false,
    loadingPage,
  }
}
